// extracted by mini-css-extract-plugin
module.exports = {"errors":"index_errors_1xGkJ","container":"index_container_3FxoE","footerNav":"index_footerNav_1fnTs"};